<template>
    <div>
       <el-row style="margin-top: 20px;">
        <el-col :lg="11">
           換貨記錄:
              <el-table
                  :data="changeLog"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="日期" prop="create_datetime">
                    
                  </el-table-column>
                  <el-table-column label="單號" prop="id"></el-table-column>
                
              </el-table>
        </el-col>
        <el-col :lg="1">
        </el-col>
        <el-col :lg="11" :offset="1">
            退貨記錄:
              <el-table
                  :data="returnLog"
                  style="width: 100%"
                 
                  
                  >
                  <el-table-column label="日期" prop="create_datetime">
                  
                  </el-table-column>
                  <el-table-column label="單號" prop="id"></el-table-column>
                 
              </el-table>
        </el-col>
    </el-row>
       
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
        name: 'chrelist',
       props: {
            orderKey: String
        },
        data() {
            return {
                changeLog: [],
                returnLog: []
            }
        },
        computed: mapGetters(["getOrderChangeLog", "getOrderReturnLog"]),
        methods: {
             ...mapActions(["fetchChreList"]),
             async fetch() {
                 const data = {_key: this.orderKey}
                  await this.$store.dispatch('fetchChreList', data)
                  console.log(this.getChangeLog)
                this.changeLog = this.getOrderChangeLog
                this.returnLog = this.getOrderReturnLog    
             }
        },
        created(){
            this.fetch()
        }
}
</script>